export { default as extra_bag } from './extra-bag.js'
export { default as trolley } from './trolley.js'
export { default as backpack } from './backpack.js'
export { default as luggage } from './luggage.js'
